import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function SoporteGraciasPage() {
  const [ticketNumber] = useState(() => {
    // Generate a random ticket number
    return `TKT-${Date.now().toString().slice(-8)}`;
  });

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50 flex items-center justify-center py-20 px-4">
      <div className="max-w-2xl w-full">
        {/* Success Card */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border border-gray-100 text-center">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-emerald-500 to-teal-500 text-white mb-6 shadow-lg shadow-emerald-500/30">
            <i className="ri-checkbox-circle-line text-5xl"></i>
          </div>

          {/* Ticket Number - Prominent Display */}
          <div className="mb-6 p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border-2 border-blue-200">
            <p className="text-sm text-gray-600 mb-2 font-semibold uppercase tracking-wide">
              Número de Ticket
            </p>
            <p className="text-4xl md:text-5xl font-bold text-blue-600 tracking-wider">
              {ticketNumber}
            </p>
          </div>

          {/* Success Message */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            ¡Ticket Generado Exitosamente!
          </h1>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Hemos recibido tu solicitud de soporte. Nuestro equipo la revisará y te responderá en menos de 2 horas.
          </p>

          {/* Info Cards */}
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 text-left">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-blue-600 text-white">
                  <i className="ri-time-line text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900">Tiempo de Respuesta</h3>
              </div>
              <p className="text-sm text-gray-600">
                Menos de 2 horas en horario laboral
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 text-left">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-600 text-white">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900">Confirmación</h3>
              </div>
              <p className="text-sm text-gray-600">
                Recibirás un email con los detalles
              </p>
            </div>
          </div>

          {/* Next Steps */}
          <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-left">
            <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-information-line text-blue-600 text-xl"></i>
              Próximos Pasos
            </h3>
            <ul className="space-y-3 text-sm text-gray-600">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-lg mt-0.5 flex-shrink-0"></i>
                <span>Recibirás un email de confirmación con tu número de ticket</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-lg mt-0.5 flex-shrink-0"></i>
                <span>Nuestro equipo revisará tu solicitud y te contactará pronto</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-lg mt-0.5 flex-shrink-0"></i>
                <span>Puedes responder al email para agregar más información</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-lg mt-0.5 flex-shrink-0"></i>
                <span>Guarda tu número de ticket para futuras referencias</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-blue-500/30 transition-all whitespace-nowrap"
            >
              <i className="ri-home-line text-xl"></i>
              Volver al Inicio
            </Link>
            <Link
              to="/soporte"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-900 border-2 border-gray-200 rounded-xl font-semibold hover:border-blue-300 hover:bg-blue-50 transition-all whitespace-nowrap"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              Centro de Soporte
            </Link>
          </div>
        </div>

        {/* Additional Help */}
        <div className="mt-8 text-center">
          <p className="text-gray-600 mb-4">
            ¿Necesitas ayuda urgente?
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://wa.me/56942470111"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-500 transition-all shadow-lg whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp
            </a>
            <a
              href="tel:+56225819100"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-500 transition-all shadow-lg whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              +56 2 2581 9100
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}